
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { ProjectListItemParam } from '@/store/modules/projects/types/projects.types';
import { useUserEmail } from '@/utils/user.util';
import BaseTable from '@/components/base/BaseTable.vue';

interface ModalParent extends Vue {
  close: () => void;
}

@Component({
  components: {
    BaseTable
  }
})
export default class UnassignEditorsForm extends Vue {
  @Prop()
  public selectedProjects!: ProjectListItemParam[];

  @Action('admin/unassignProjectEditors')
  public unassignProjectEditors!: (payload: any) => void;

  public note = '';
  public selectedProjectIds: number[] = [];

  mounted() {
    // Initially select all projects
    this.selectedProjectIds = this.assignedProjects.map((p) => p.projectId);
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get selectedCount() {
    return this.selectedProjectIds.length;
  }

  get assignedProjects() {
    return this.selectedProjects.filter((project) => project.editorId);
  }

  public async handleUnassign() {
    if (this.userEmail) {
      const selectedProjects = this.assignedProjects.filter((p) =>
        this.selectedProjectIds.includes(p.projectId)
      );

      await this.unassignProjectEditors({
        adminEmail: this.userEmail,
        projects: selectedProjects.map((p) => ({
          projectId: p.projectId,
          editorId: p.editorId,
          editorEmail: p.editorEmail,
          editorName: p.editorName
        })),
        note: this.note || undefined
      });
    }
    (this.$parent as ModalParent).close();
  }
}
